import React, { Component } from "react";

// Components
import LoginForm from "./LoginForm";
import LoginLinks from "./LoginLinks";
import SuggestedProducts from "../SuggestedProducts";

// CSS
import "../../css/login.css";

class CustomerLogin extends Component {
	render() {
		return (
			<div className="body_container padded_top padded_bottom">
				<main>
					<h1>Customer Login</h1>

					<div className="product_section">
						<LoginForm />
						<LoginLinks />
					</div>
				</main>

				<SuggestedProducts />
			</div>
		);
	}
}

export default CustomerLogin;



// WEBPACK FOOTER //
// ./src/components/customer/CustomerLogin.js